

// --- Configuración ---
// const BACKEND_WS_URL = 'ws://localhost:5002/ws'; // Ajusta si es necesario
const BACKEND_WS_URL = process.env.REACT_APP_LIVE_ASSISTANT; // Ajusta si es necesario
// const BACKEND_WS_URL = 'wss://8f22-2800-cd0-afc1-d200-e935-9d4c-b670-6018.ngrok-free.app/ws'; // Ajusta si es necesario
const AUDIO_REQUESTED_SAMPLE_RATE = 16000;
const AUDIO_BUFFER_SIZE = 4096;
const VIDEO_FRAME_INTERVAL_MS = 1000; // 1 frame por segundo
const GEMINI_AUDIO_OUTPUT_SAMPLE_RATE = 24000;
const AUDIO_OUTPUT_GAIN = 2.0;

// --- Referencias a Elementos del DOM ---
let btnToggleMic = document.getElementById('btn-toggle-mic');
// let btnToggleCamera = document.getElementById('btn-toggle-camera'); // Descomentar si lo usas
let btnShareScreen = document.getElementById('btn-share-screen'); // Asegúrate que la referencia exista
let btnToggleStream = document.getElementById('btn-toggle-stream');
const chatbox = document.querySelector(".chatbox");
// const chatInput = document.querySelector(".chat-input textarea"); // Comentado en tu HTML
// const sendChatBtn = document.querySelector(".chat-input span"); // Comentado en tu HTML
const errorMessageDiv = document.getElementById('error-message');
// --- Añadir referencias para la vista previa de video ---
// (Asegúrate de tener estos elementos en tu HTML si quieres vista previa)
// const videoPreviewContainer = document.getElementById('video-preview-container'); // Comentado en tu HTML
// const localVideoPreview = document.getElementById('local-video-preview');       // Comentado en tu HTML
// --- Alternativa si la preview está dentro del chatbox ---
let videoPreviewContainer = null;
let localVideoPreview = null;


// --- Estado de la Aplicación ---
let ws = null;
let audioContext = null;
let gainNode = null;
let audioStreamSource = null;
let scriptProcessorNode = null;
let localAudioStream = null; // Stream del microfono
let localVideoStream = null; // Stream de video/pantalla ACTUAL
let videoInterval = null;
let audioQueue = [];
let isPlayingAudio = false;
let isConnected = false;
let isStreaming = false;
let isMicMuted = false;
let isScreenSharingActive = false; // Nuevo estado para indicar si se comparte pantalla AHORA
let isCameraActive = false; // Nuevo estado para indicar si la cámara está activa AHORA (si implementas ese botón)


// --- Helper: ArrayBuffer a Base64 ---
function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

// --- Helper: Mostrar Mensaje en Chat ---
const createChatLi = (message, className, isHtml = false) => {
    const chatLi = document.createElement("li");
    chatLi.classList.add("chat", className);
    let chatContent = className === "outgoing" ? `<p></p>` : `<span><img src="../static/assets/images/avatar.png" style="height: 40px;"></span><p></p>`;
    chatLi.innerHTML = chatContent;
    if (isHtml) {
            chatLi.querySelector("p").innerHTML = message; // Para insertar HTML como el video
    } else {
            chatLi.querySelector("p").textContent = message;
    }

    return chatLi;
}

const addMessageToChat = (sender, text) => {
    const messageClass = sender === 'user' ? 'outgoing' : 'incoming';
    const li = createChatLi(text, messageClass);
    chatbox.appendChild(li);
    chatbox.scrollTo(0, chatbox.scrollHeight); // Auto-scroll
}

let globalError = null;

// --- Helper: Mostrar Error ---
const setError = (message) => {
    // console.error("Error:", message); // Descomenta para ver errores en consola
    globalError = message
}

// --- Conexión WebSocket ---
const connectWebSocket = () => {
    if (ws && ws.readyState === WebSocket.OPEN) return;
    console.log(`Intentando conectar a ${BACKEND_WS_URL}...`);
    setError(null); // Limpiar errores previos
    ws = new WebSocket(BACKEND_WS_URL);

    ws.onopen = () => {
        console.log('WebSocket Conectado');
        isConnected = true;
        setError(null);
        updateButtonStates(); // Actualizar botones (ej. habilitar 'Iniciar Stream')
        // iniciar streaming luego de conectar
        startStreaming();
    };

    ws.onclose = (event) => {
        console.log('WebSocket Desconectado:', event.reason, event.code);
        isConnected = false;
        // Si el stream estaba activo, detenerlo forzosamente
        if (isStreaming) {
            stopStreamingInternal(false); // false indica que no fue iniciado por el usuario
        }
        updateButtonStates();
        if (!event.wasClean) {
            setError(`Conexión perdida: ${event.reason || 'Error desconocido'} (Código: ${event.code})`);
        }
        ws = null; // Limpiar la instancia
    };

    ws.onerror = (err) => {
        console.error('WebSocket Error:', err);
        isConnected = false;
        if (isStreaming) {
            stopStreamingInternal(false);
        }
        setError('Error en la conexión WebSocket.');
        updateButtonStates();
        ws = null;
    };

    ws.onmessage = (event) => {
        try {
            const message = JSON.parse(event.data);
            // console.debug('Mensaje recibido:', message.type);
            if (message.type === 'text') {
                addMessageToChat('gemini', message.data);
            } else if (message.type === 'audio') {
                const audioBytes = Uint8Array.from(atob(message.data), c => c.charCodeAt(0));
                audioQueue.push(audioBytes.buffer);
                playQueuedAudio(); // Intenta reproducir inmediatamente
            } else if (message.type === 'error') {
                setError(`Error del servidor: ${message.message}`);
            }
        } catch (e) {
            console.error('Error procesando mensaje:', e, event.data);
            setError("Error procesando mensaje del servidor.");
        }
    };
};
let wavesInterval=null;
function startWaves() {  
    
    const waveElements = document.querySelectorAll('.wave-ai');  

    wavesInterval = setInterval(() => {
        waveElements.forEach(wave => {  
            const randomHeight = Math.floor(Math.random() * 30) + 5; // Random height between 1px and 100px  
            wave.style.height = `${randomHeight}px`;  
        });  
    }, 200);  
}  

function updateUserWaves(value) {  
    const waveElements = document.querySelectorAll('.wave-user');  
    const randomIndex = Math.floor(Math.random() * waveElements.length);
    const randomHeight = Math.floor(Math.min(Math.abs(value)/100, 20)) + 5; // Random height between 1px and 100px  
    waveElements[randomIndex].style.height = `${randomHeight}px`;  
}  

function stopWaves() {  
    const waveElements = document.querySelectorAll('.wave-ai');  
    clearInterval(wavesInterval);
    waveElements.forEach(wave => {  
        const randomHeight = 5; // Random height between 1px and 100px  
        wave.style.height = `${randomHeight}px`;  
    }); 
} 

// --- Reproducción de Audio ---
const playQueuedAudio = async () => {
    // console.log(`>>> Playback AudioContext REAL sample rate: ${audioContext?.sampleRate} Hz`);
    if (isPlayingAudio || audioQueue.length === 0) return;

    // Recrear o crear AudioContext si es necesario (para reproducción)
    // Usamos el mismo contexto que para la entrada si ya existe y está corriendo
    let playbackContext = audioContext;
    if (!playbackContext || playbackContext.state === 'closed') {
        try {
            console.log("Creando/Reanudando AudioContext para reproducción...");
            playbackContext = new (window.AudioContext || window.webkitAudioContext)();
            if (playbackContext.state === 'suspended') await playbackContext.resume();
            // Si creamos uno nuevo aquí, podríamos asignarlo a la variable global `audioContext`
            // si el de entrada no existía o estaba cerrado.
            if (!audioContext || audioContext.state === 'closed') {
                audioContext = playbackContext;
            }
        } catch (e) {
            console.error("Error creando/reanudando AudioContext para reproducción:", e);
            setError("No se pudo inicializar audio para reproducción.");
            return;
        }
    } else if (playbackContext.state === 'suspended') {
        try {
            await playbackContext.resume();
        } catch (e) {
            console.error("Error reanudando AudioContext para reproducción:", e);
            setError("No se pudo reanudar audio para reproducción.");
            return;
        }
    }

    // Asegurarse de que el GainNode pertenezca al AudioContext actual.
    // Si no existe o pertenece a un contexto diferente (anterior), se crea uno nuevo.
    if (!gainNode || gainNode.context !== playbackContext) {
        console.log("Creando o recreando GainNode para el AudioContext actual.");
        gainNode = playbackContext.createGain();
        gainNode.gain.value = AUDIO_OUTPUT_GAIN; // ¡Aplica el volumen que definimos!
        gainNode.connect(playbackContext.destination); // Conecta el GainNode al altavoz
    }

    isPlayingAudio = true;
    startWaves();
    
    // updateButtonStates(); // No es necesario actualizar botones solo por reproducir audio

    while (audioQueue.length > 0) {
        const audioBufferChunk = audioQueue.shift();
        if (!audioBufferChunk || audioBufferChunk.byteLength === 0) continue;

        try {
            // Asegurarse que el contexto sigue válido
            if (playbackContext.state === 'closed') {
                console.warn("AudioContext cerrado durante reproducción, deteniendo.");
                isPlayingAudio = false;
                stopWaves();
                audioQueue = []; // Limpiar cola
                // updateButtonStates(); // No necesario aquí tampoco
                return;
            }

            const pcm16Data = new Int16Array(audioBufferChunk);
            const float32Data = new Float32Array(pcm16Data.length);
            for (let i = 0; i < pcm16Data.length; i++) {
                float32Data[i] = pcm16Data[i] / 32768.0; // Convertir Int16 a Float32
            }

            const audioBuffer = playbackContext.createBuffer(
                1, // num channels
                float32Data.length, // num frames
                GEMINI_AUDIO_OUTPUT_SAMPLE_RATE // sample rate
            );
            audioBuffer.copyToChannel(float32Data, 0); // channel 0

            const source = playbackContext.createBufferSource();
            source.buffer = audioBuffer;
            // source.connect(playbackContext.destination);
            source.connect(gainNode);

            // Esperar a que termine de reproducirse este chunk
            await new Promise((resolve, reject) => {
                source.onended = resolve;
                try {
                    source.start();
                } catch (startError) {
                    console.error("Error al iniciar audio chunk:", startError);
                    reject(startError); // Rechazar la promesa si no se puede iniciar
                }
            });
            source.disconnect(); // Limpiar conexión

        } catch (decodeError) {
            console.error('Error decodificando/reproduciendo audio chunk:', decodeError);
            // Continuar con el siguiente chunk si es posible
        }
    }

    isPlayingAudio = false;
    stopWaves();
    // updateButtonStates(); // No necesario
    // Opcional: Volver a comprobar la cola por si llegaron más mientras se reproducía
    // setTimeout(playQueuedAudio, 50);
};

// --- Envío de Datos (Audio, Video, Texto) ---
const sendData = (data) => {
    if (ws && ws.readyState === WebSocket.OPEN) {
        // console.debug("Enviando data:", data.type);
        try {
            ws.send(JSON.stringify(data));
        } catch (sendError) {
            console.error("Error enviando datos por WebSocket:", sendError);
            setError("Error al enviar datos al servidor.");
            // Considerar cerrar la conexión o reintentar si es crítico
        }
    } else {
        console.warn('WebSocket no abierto al intentar enviar.');
        setError("La conexión no está activa.");
        if (isStreaming) {
            stopStreamingInternal(false); // Detener si falla el envío durante stream
        }
        updateButtonStates();
    }
};

// --- Iniciar Streaming (Solo audio inicialmente) ---
let userWavesCounter = 0;
const startStreaming = async () => {
    if (!isConnected) {
        setError("No conectado al servidor. Intentando reconectar...");
        connectWebSocket();
        return;
    }
    if (isStreaming) {
        setError("El streaming ya está activo.");
        return;
    }

    console.log("Iniciando streaming (solo audio inicialmente)...");
    setError(null);
    isStreaming = true;
    updateButtonStates();

    try {
        // 1. Solicita acceso al micrófono.
        console.log(`Solicitando stream de audio...`);
        localAudioStream = await navigator.mediaDevices.getUserMedia({
            audio: {
                // Ya no necesitamos sugerir una tasa aquí, usaremos la que nos dé el sistema.
                channelCount: 1,
                echoCancellation: true,
                noiseSuppression: true,
            },
            video: false
        });

        // 2. Crea el AudioContext.
        //    Dejamos que se cree con la tasa por defecto del sistema para máxima compatibilidad.
        if (!audioContext || audioContext.state === 'closed') {
            console.log("Creando nuevo AudioContext para entrada...");
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }
        if (audioContext.state === 'suspended') {
            await audioContext.resume();
        }

        console.log(`AudioContext de entrada operando a ${audioContext.sampleRate}Hz.`);
        console.log(`El audio se remuestreará y enviará a ${AUDIO_REQUESTED_SAMPLE_RATE}Hz.`);

        // 3. Carga el módulo del AudioWorklet.
        //    La ruta debe ser accesible desde tu HTML (ej. '/resampler-worklet.js' si está en public/).
        try {
            await audioContext.audioWorklet.addModule('resampler-worklet.js');
        } catch (e) {
            console.error("Error al cargar el módulo del AudioWorklet:", e);
            setError("No se pudo cargar el procesador de audio. Intenta recargar la página.");
            stopStreamingInternal(false);
            return;
        }

        // 4. Crea el nodo del Worklet y conéctalo.
        audioStreamSource = audioContext.createMediaStreamSource(localAudioStream);

        const resamplerNode = new AudioWorkletNode(audioContext, 'resampler-processor', {
            processorOptions: {
                outputSampleRate: AUDIO_REQUESTED_SAMPLE_RATE // Le decimos al worklet a qué tasa convertir
            }
        });

        // 5. Escucha los mensajes del Worklet (que contienen el audio ya remuestreado).
        resamplerNode.port.onmessage = (event) => {
            if (isMicMuted || !isConnected || !isStreaming) return;

            const resampledInt16Buffer = event.data; // Esto ya es un Int16Array

            // Actualizar las ondas de la UI (opcional, puedes usar el último valor)
            userWavesCounter++;
            if (userWavesCounter % 2 === 0 && resampledInt16Buffer.length > 0) {
                updateUserWaves(resampledInt16Buffer[resampledInt16Buffer.length - 1]);
            }

            const base64AudioPCM = arrayBufferToBase64(resampledInt16Buffer.buffer);

            // ¡Importante! Enviamos la tasa de muestreo FIJA que el backend espera.
            sendData({
                type: 'audio',
                mime_type: `audio/pcm;rate=${AUDIO_REQUESTED_SAMPLE_RATE}`,
                data: base64AudioPCM
            });
        };

        // Conectamos la fuente de audio al worklet.
        // No necesitamos conectar el worklet al 'destination' si no queremos escuchar el audio procesado.
        audioStreamSource.connect(resamplerNode);

        // Guardamos la referencia al nodo para poder desconectarlo después.
        // Reutilizamos la variable scriptProcessorNode para no cambiar el resto del código.
        scriptProcessorNode = resamplerNode;

        console.log("AudioWorklet configurado para remuestrear y procesar PCM.");

        // Lógica restante...
        localVideoStream = null;
        isScreenSharingActive = false;
        isCameraActive = false;
        isStreaming = true;
        console.log("Streaming de AUDIO iniciado.");

    } catch (err) {
        // ... (tu manejo de errores se mantiene igual)
        console.error('Error general al iniciar media stream:', err);
        let userMessage = `Error al acceder a dispositivos: ${err.message || err.name || 'desconocido'}`;
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') userMessage = 'Permiso denegado para micrófono/cámara.';
        else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') userMessage = 'No se encontraron dispositivos.';
        else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') userMessage = 'Dispositivo ya en uso o no se puede leer.';
        else if (err.name === 'OverconstrainedError' || err.name === 'ConstraintNotSatisfiedError') userMessage = `Parámetros solicitados no soportados.`;
        setError(userMessage);
        stopStreamingInternal(false);
    } finally {
        updateButtonStates();
    }
};

// --- Detener Video Stream (Función Auxiliar) ---
const stopVideoStreamInternal = () => {
    console.log("Deteniendo video stream actual (si existe)...");
    if (videoInterval) {
        clearInterval(videoInterval);
        videoInterval = null;
        console.log("Intervalo de video detenido.");
    }
    if (localVideoStream) {
        localVideoStream.getTracks().forEach(track => track.stop());
        localVideoStream = null;
        console.log("Tracks de video detenidos.");
    }
    // Remover el elemento de video del DOM si existe
    if (videoPreviewContainer && videoPreviewContainer.parentNode) {
            videoPreviewContainer.parentNode.removeChild(videoPreviewContainer);
            videoPreviewContainer = null; // Limpiar referencia
            localVideoPreview = null;     // Limpiar referencia
    }

    isScreenSharingActive = false;
    isCameraActive = false; // Asegurarse de resetear ambos estados de video
}

// --- Iniciar Video Stream (Función Auxiliar) ---
const startVideoStreamInternal = (stream, mode) => {
    console.log(`Iniciando video stream para ${mode}...`);
    localVideoStream = stream;

    // Crear dinámicamente el contenedor y el video si no existen
    if (!videoPreviewContainer) {
            const videoLi = document.createElement("li");
            videoLi.id = "video-preview-container"; // Asignar ID
            videoLi.classList.add("chat", "video-preview"); // Añadir clases si necesitas estilos específicos
            videoLi.style.textAlign = "center"; // Estilo básico

            const videoEl = document.createElement("video");
            videoEl.id = "local-video-preview"; // Asignar ID
            videoEl.muted = true;
            videoEl.playsInline = true;
            videoEl.style.maxWidth = "100%";
            videoEl.style.maxHeight = "150px"; // O el tamaño que prefieras
            videoEl.style.border = "1px solid #ccc";
            videoEl.style.backgroundColor = "#eee";

            videoLi.appendChild(videoEl);
            chatbox.appendChild(videoLi); // Añadir al chatbox
            chatbox.scrollTo(0, chatbox.scrollHeight); // Scroll para verlo

            videoPreviewContainer = videoLi; // Guardar referencia
            localVideoPreview = videoEl;     // Guardar referencia
    }


    if(localVideoPreview) {
        localVideoPreview.srcObject = localVideoStream;
        localVideoPreview.play().catch(e => console.error("Error al reproducir vista previa:", e));
        videoPreviewContainer.style.display = 'block'; // Asegurarse que esté visible
    } else {
        console.error("No se pudo crear o encontrar el elemento de video para la vista previa.");
        // Considerar detener el stream de video si la preview es esencial
        stopVideoStreamInternal();
        return; // Salir si no hay preview
    }


    // Iniciar intervalo para enviar frames
    if (videoInterval) clearInterval(videoInterval); // Limpiar anterior
    videoInterval = setInterval(() => {
        // Asegurarse que localVideoPreview todavía existe y es válido
        if (!localVideoPreview || localVideoPreview.paused || localVideoPreview.ended || localVideoPreview.videoWidth === 0 || !isStreaming) {
            return;
        }
        try {
            // --- Lógica de captura y envío de frames ---
            const canvas = document.createElement('canvas');
            canvas.width = localVideoPreview.videoWidth;
            canvas.height = localVideoPreview.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(localVideoPreview, 0, 0, canvas.width, canvas.height);
            const frameDataUrl = canvas.toDataURL('image/jpeg', 0.7);
            const base64Frame = frameDataUrl.split(',')[1];
            if (base64Frame) {
                sendData({ type: 'video', mime_type: 'image/jpeg', data: base64Frame });
            }
        } catch (frameError) {
            console.error("Error capturando/enviando frame:", frameError);
            // Podrías detener el intervalo si hay errores repetidos
            // clearInterval(videoInterval); videoInterval = null;
            // stopVideoStreamInternal(); // O detener todo el video stream
            // updateButtonStates();
        }
    }, VIDEO_FRAME_INTERVAL_MS);
    console.log(`Intervalo de video (${mode}) iniciado.`);

    if (mode === 'screen') {
        isScreenSharingActive = true;
        isCameraActive = false;
            // Escuchar si el usuario detiene la compartición desde el navegador
            localVideoStream.getVideoTracks()[0].onended = () => {
            console.log("El usuario detuvo la compartición de pantalla desde el navegador.");
            // Solo detener la parte de video si aún estamos en streaming general
            if (isStreaming) {
                stopVideoStreamInternal();
                updateButtonStates(); // Actualizar botones
            }
        };
    } else if (mode === 'camera') {
        isCameraActive = true;
        isScreenSharingActive = false;
    }
}


// --- Detener Streaming (Lógica interna - Modificada) ---
const stopStreamingInternal = (notifyServer = true) => {
    if (!isStreaming && !localAudioStream && !localVideoStream) {
            console.log("Intento de detener stream, pero ya estaba detenido o limpiado.");
            return;
    }
    console.log("Deteniendo streaming (interno)...");
    isStreaming = false; // Marcar como detenido

    // Notificar al backend
    if (notifyServer && isConnected) {
            try {
                // sendData({ type: 'control', action: 'stop_stream' }); // Si tu backend lo necesita
                console.log("Notificación de fin de stream (si aplica) no implementada.");
            } catch (e) { console.warn("No se pudo notificar al servidor el fin del stream:", e); }
    }

    // 1. Detener Video Stream (usando la nueva función auxiliar)
    stopVideoStreamInternal();

    // 2. Desconectar y limpiar nodos de Web Audio API
    if (scriptProcessorNode) {
        scriptProcessorNode.disconnect();
        scriptProcessorNode.onaudioprocess = null;
        scriptProcessorNode = null;
        console.log("ScriptProcessorNode desconectado.");
    }
    if (audioStreamSource) {
        audioStreamSource.disconnect();
        audioStreamSource = null;
        console.log("MediaStreamSource desconectado.");
    }

    // 3. Detener stream de audio local
    if (localAudioStream) {
        localAudioStream.getTracks().forEach(track => track.stop());
        localAudioStream = null;
        console.log("Stream de audio local detenido.");
    }

    // 4. Considerar cerrar AudioContext
    // if (audioContext && audioContext.state !== 'closed') {
    //     audioContext.close().then(() => console.log("AudioContext cerrado."));
    //     audioContext = null;
    // }

    // 5. Limpiar cola de audio y estado de reproducción
    audioQueue = [];
    isPlayingAudio = false;

    // 6. Resetear estados de control
    isMicMuted = false;
    // isCameraActive y isScreenSharingActive ya se resetean en stopVideoStreamInternal

    // 7. Cerrar la conexion al websocket
    if (ws && ws.readyState === WebSocket.OPEN) {
        console.log("cerrando conexion WebSocket...");
        ws.close(1000, "Fin de streaming by user");
        // ws = null;
        console.log("WebSocket cerrado.");
    } else if (ws && (ws.readyState === WebSocket.CONNECTING || ws.readyState === WebSocket.CLOSING)) {
        console.log("WebSocket ya cerrado o cerrándose.");
    } else {
        // console.log("WebSocket no abierto o ya cerrado.");
        isConnected = false;
    }

    console.log("Streaming detenido y recursos liberados.");
    updateButtonStates(); // Actualizar UI al final
};

// --- Función Pública para Detener Streaming ---
const stopStreaming = () => {
    stopStreamingInternal(true); // Notificar al servidor por defecto
}

// --- Enviar Texto (Asegúrate que chatInput y sendChatBtn existan si descomentas esto) ---
// const handleSendText = () => {
//     const userMessage = chatInput.value.trim();
//     if (!userMessage) return;
//     if (!isConnected) {
//         setError("No conectado. Intenta reconectar o iniciar stream.");
//         return;
//     }
//     addMessageToChat('user', userMessage);
//     chatInput.value = "";
//     sendData({type: 'text', data: userMessage, end_of_turn: true});
// };

// --- Control de Micrófono (Mute/Unmute) ---
const toggleMicrophone = () => {
    console.log(isStreaming);
    if (!isStreaming) return; // Solo funciona durante el stream
    isMicMuted = !isMicMuted;
    console.log("Mic Muted:", isMicMuted);
    // La lógica de muteo ya está en scriptProcessorNode.onaudioprocess
    updateButtonStates();
};

// --- Control de Cámara (Función para iniciar/detener DURANTE stream - si la necesitas) ---
// const toggleCamera = async () => { ... } // Implementación omitida por brevedad, similar a toggleScreenShare

// --- Control de Pantalla (Función para iniciar/detener DURANTE stream) ---
const toggleScreenShare = async () => {
    if (!isStreaming) {
        setError("Inicia el streaming primero.");
        return; // Solo funciona durante el stream
    }
        setError(null); // Limpiar errores

    if (isScreenSharingActive) {
        // Detener compartición de pantalla
        console.log("Deteniendo compartición de pantalla...");
        stopVideoStreamInternal(); // Detiene cualquier video activo (en este caso, la pantalla)
    } else {
        // Iniciar compartición de pantalla
        console.log("Iniciando compartición de pantalla...");
        // if (isCameraActive) { // Si la cámara está activa, detenerla primero (opcional)
        //     console.log("Deteniendo cámara para iniciar compartición de pantalla...");
        //     stopVideoStreamInternal();
        // }
        try {
            const stream = await navigator.mediaDevices.getDisplayMedia({
                video: { width: 640, height: 480 }, // O ajusta constraints
                audio: false // Generalmente no se captura audio de pantalla aquí
            });
            startVideoStreamInternal(stream, 'screen'); // Inicia el stream de video y el intervalo
        } catch (err) {
            console.error("Error al iniciar compartición de pantalla:", err);
            // El usuario pudo haber cancelado (DOMException 'NotAllowedError')
            if (err.name !== 'NotAllowedError') {
                    setError(`No se pudo compartir pantalla: ${err.message || err.name}`);
            } else {
                    console.log("El usuario canceló la compartición de pantalla."); // No mostrar error si cancela
            }
            stopVideoStreamInternal(); // Asegurar limpieza si falla o se cancela
        }
    }
    updateButtonStates(); // Actualizar botones después de la acción
};

// --- Actualizar Apariencia de Botones ---
function updateButtonStates() {
    const canStartStream = isConnected && !isStreaming;
    const canStopStream = isStreaming;

    // Botón Micrófono
    if (btnToggleMic) {
        btnToggleMic.disabled = !isStreaming;
        btnToggleMic.classList.toggle('muted', isMicMuted);
        btnToggleMic.querySelector('.material-symbols-outlined').textContent = isMicMuted ? 'mic_off' : 'mic';
        btnToggleMic.title = isMicMuted ? "Activar Micrófono" : "Silenciar Micrófono";
    }

    // Botón Cámara (si existe)
    // if (btnToggleCamera) { ... }

    // Botón Pantalla
    if (btnShareScreen) {
        // Habilitado solo si el streaming está activo.
        // Podrías deshabilitarlo si la cámara está activa, si no permites ambos.
        btnShareScreen.disabled = !isStreaming; // || isCameraActive;
        btnShareScreen.classList.toggle('active', isScreenSharingActive); // 'active' si se está compartiendo AHORA
        btnShareScreen.querySelector('.material-symbols-outlined').textContent = isScreenSharingActive ? 'stop_screen_share' : 'screen_share';
        btnShareScreen.title = isScreenSharingActive ? "Dejar de compartir" : "Compartir Pantalla";
    }

    // Botón Iniciar/Detener Stream
    if (btnToggleStream) {
        // btnToggleStream.disabled = !(canStartStream || canStopStream); // Habilitado si se puede iniciar o detener
        btnToggleStream.classList.toggle('streaming', isStreaming); // Estilo rojo si está en stream
        // btnToggleStream.querySelector('.material-symbols-outlined').textContent = isStreaming ? 'call_end' : 'play_arrow';
        // btnToggleStream.title = isStreaming ? "Detener Llamada (Colgar)" : "Iniciar Llamada";
    }

    // Habilitar/deshabilitar input de texto (si existen los elementos)
    // if (chatInput) chatInput.disabled = !isConnected;
    // if (sendChatBtn) sendChatBtn.style.pointerEvents = isConnected ? 'auto' : 'none';
}


// export const toggleMicrophoneHandler = toggleMicrophone;

export const setupLiveApi = () => {
        btnToggleMic = document.getElementById('btn-toggle-mic');
        // btnToggleCamera = document.getElementById('btn-toggle-camera'); // Descomentar si lo usas
        btnShareScreen = document.getElementById('btn-share-screen'); // Asegúrate que la referencia exista
        btnToggleStream = document.getElementById('btn-toggle-stream');
        // --- Añadir Event Listeners ---
        // console.log("mic button", btnToggleMic);
        if (btnToggleMic) btnToggleMic.addEventListener('click', toggleMicrophone);
        // if (btnToggleCamera) btnToggleCamera.addEventListener('click', toggleCamera); // Descomentar si usas cámara
        if (btnShareScreen) btnShareScreen.addEventListener('click', toggleScreenShare); // Listener para el botón de pantalla

        // Listeners para el input de texto (si existen los elementos)
        // if (sendChatBtn) sendChatBtn.addEventListener("click", handleSendText);
        // if (chatInput) chatInput.addEventListener("keydown", (e) => {
        //     if (e.key === "Enter" && !e.shiftKey) {
        //         e.preventDefault();
        //         handleSendText();
        //     }
        // });

        // --- Inicialización ---
        // connectWebSocket(); // Intentar conectar al cargar la página/modal
        updateButtonStates(); // Establecer estado inicial de los botones

        // Limpieza al cerrar la ventana/modal (opcional pero recomendado)

        // const visualizerContainer = document.getElementById('voiceVisualizer');  
        // console.log("sdsd", visualizerContainer);
        // if (visualizerContainer) createWaves(visualizerContainer, 32); // Create 32 waves
        


}; // Fin DOMContentLoaded

export function toggleStream(){
    setError(null); // Limpiar errores al intentar acción
    if (isStreaming) {
        stopStreaming();
    } else if (isConnected) {
        startStreaming();
    } else {
        setError("No conectado. Intentando conectar...");
        console.log("NO conectado. Intentando conectar...");
        connectWebSocket(); // Intentar conectar si se pulsa iniciar sin conexión
    }
    

    return new Promise((res, rej) => {
        let id = setInterval(()=> {
            if (ws && ws.readyState === WebSocket.OPEN){
                res('ready');
                clearInterval(id);
            }
            else if(globalError != null){
                rej(globalError)
                clearInterval(id);
            }
        }, 1000)
    })
}

export function closeStreaming() {
    if (btnToggleMic) btnToggleMic.removeEventListener('click', toggleMicrophone);
    // if (btnToggleCamera) btnToggleCamera.removeEventListener('click', toggleCamera); // Descomentar si usas cámara
    if (btnShareScreen) btnShareScreen.removeEventListener('click', toggleScreenShare); // Listener para el botón de pantalla
    
    if (isStreaming) {
        stopStreamingInternal(true); // Intentar detener limpiamente
    }
    if (ws && ws.readyState === WebSocket.OPEN) {
        ws.close();
    }
};
